import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import { productsData, typeData, storiesData } from './data';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger, KTab, KScrollspy } from './common/k-tools/k-tools.js';
import productColorSwitch from './common/colorChips.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import videoPlayer from './common/videoPlayer.js';
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';

const swiperHandler = {};
swiperHandler.feature = () => {
  let featureSwiper;
  const featureSwiperInit = () => {
    featureSwiper = new Swiper('.feature-swiper', {
      slidesPerView: 1,
      navigation: {
        nextEl: '.feature-swiper .swiper-button-next',
        prevEl: '.feature-swiper .swiper-button-prev',
      },
      pagination: {
        el: '.feature-swiper .swiper-pagination',
        clickable: true,
      },
    });
  };

  const checkScreenWidth = () => {
    const viewWidth = window.innerWidth;
    if (viewWidth < 1000) {
      featureSwiperInit();
    } else {
      if (featureSwiper) {
        featureSwiper.destroy(true, true);
        featureSwiper = null;
      }
    }
  };

  checkScreenWidth();
  $(window).on('resize', checkScreenWidth);
};
swiperHandler.category = () => {
  $('.pickup__slider').each((index, el) => {
    const galleryTop = $(el).find('.gallery-top')[0];
    const galleryThumbs = $(el).find('.gallery-thumbs')[0];
    const galleryThumbsSwiper = new Swiper(galleryThumbs, {
      slidesPerView: 'auto',
      lazy: {
        loadPrevNext: true,
      },
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    const galleryTopSwiper = new Swiper(galleryTop, {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: false,
      loop: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      thumbs: {
        swiper: galleryThumbsSwiper,
      },
    });
  });
};
swiperHandler.all = () => {
  swiperHandler.feature();
  swiperHandler.category();
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });
  const tab = new KTab('[k-tab]', {
    history: true,
    onChange: tab => {
      scrollTrigger.reset(tab.activePanelEl, '[k-st]');
      gsapAnimationUpdate();
    },
  });

  swiperHandler.all();
  productColorSwitch();
  gsapAnimation();
  videoPlayer();
};

// Vue
createApp({
  setup() {
    const productsDataRef = ref(productsData);
    const typeDataRef = ref(typeData);
    const storiesDataRef = ref(storiesData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      productsDataRef,
      typeDataRef,
      storiesDataRef,
    };
  },
}).mount('#main');
